import Icon from '../components/Icon.vue'

Icon.register({
  kiss: {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM168 240C150.3 240 136 225.7 136 208S150.3 176 168 176 200 190.3 200 208 185.7 240 168 240zM304 396C304 415.2 275.3 437.5 232.5 440 224 440.8 220.4 428.2 228.9 424.6L245.9 417.4C258.9 411.9 266.7 403.9 266.7 395.9S258.9 379.9 245.9 374.4L228.9 367.2C222.9 364.7 222.8 355 228.9 352.4L245.9 345.2C258.9 339.7 266.7 331.7 266.7 323.7S258.9 307.7 245.9 302.2L228.9 295C220.3 291.4 224.1 278.5 232.5 279.6 275.3 282.1 304 304.4 304 323.6 304 336.6 290.6 350.9 268.8 359.6 290.6 368.7 304 383 304 396zM328 240C310.3 240 296 225.7 296 208S310.3 176 328 176 360 190.3 360 208 345.7 240 328 240z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/kiss.js
// module id = apOH
// module chunks = 144